<!-- [mkotormus] TODO: consider turning all the child toolbars into dynamic components
 and just have simple ngFor here. This can allow to register toolbars at runtime, if
 that is ever required -->
<div class="action-bar"
    [class.collapsed-bar]="hasActiveChildToolbars && !showMaximizedToolbar"
    [class.expanded-bar]="hasActiveChildToolbars && showMaximizedToolbar">
    <span class="inline-container" [class.hide-inline-container]="!(hasActiveChildToolbars && showMaximizedToolbar)">
      <span
        [style.visibility]="hasActiveChildToolbars && showMaximizedToolbar ? 'visible' : 'hidden'"
        *ngFor="let toolbar of toolbars; last as isLast"
        [ngSwitch]="toolbar">
        <app-remote-control-annotations-toolbar
        *ngSwitchCase="'annotation'"
        class="inline-container"
        (canMinimize)="setCanMinimize('annotation', $event)"
        [isDisabled]="isDisabled"></app-remote-control-annotations-toolbar>
        <app-remote-control-video-recording-toolbar
        *ngSwitchCase="'videoRecording'"
        class="inline-container"
        [rcState]="rcState"></app-remote-control-video-recording-toolbar>
        <div class="action-bar-divider" *ngIf="!isLast"></div>
      </span>
    </span>
    <span class="menu-indicator-container"
         *ngIf="hasActiveChildToolbars && !showMaximizedToolbar">
            <span class="hd-icon icon-lg hd-icon-menu menu-indicator"></span>
    </span>
</div>
